import React, { FunctionComponent, memo } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const LoadingComponent: FunctionComponent = () => {
    const icon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
    return <Spin indicator={icon} />;
};

export default memo(LoadingComponent);
